import ClientsRequests from '../../server/clients';
import { addLoading, removeLoading } from './loading';

export const setClients = res => ({
  type: 'PANEL_GET_CLIENTS',
  clients: res,
});
export const setClientsSettings = res => ({
  type: 'PANEL_GET_CLIENTS_SETTINGS',
  clientsSettings: res,
});
export const setSearchedClients = searched => ({
  type: 'PANEL_GET_CLIENTS_SEARCH',
  searched,
});

const createClients = client => async (dispatch) => {
  dispatch(addLoading());
  try {
    await ClientsRequests.createClient(client);
  } finally {
    dispatch(removeLoading());
  }
};

const updateClients = client => async (dispatch) => {
  dispatch(addLoading());
  try {
    await ClientsRequests.updateClient(client);
  } finally {
    dispatch(removeLoading());
  }
};

const getClientSettings = nameAbbr => async (dispatch) => {
  dispatch(addLoading());
  try {
    const clientSettings = await ClientsRequests.getClientSettings(nameAbbr);
    dispatch(setClientsSettings(clientSettings));
  } finally {
    dispatch(removeLoading());
  }
};

const getClient = (limit, skip, search, force = false, order = '', field = '') => async (dispatch) => {
  if (!search || force) dispatch(addLoading());
  try {
    const client = await ClientsRequests.getClient(limit, skip, search, order, field);
    dispatch(setClients(client));
  } finally {
    if (!search || force) dispatch(removeLoading());
  }
};

const searchSphereClient = (limit, search) => async (dispatch) => {
  const client = await ClientsRequests.searchSphereClient(limit, search);
  dispatch(setSearchedClients(client));
};

const uploadClientLogo = async (file, name, id) => ClientsRequests.uploadClientLogo(file, name, id);

export const uploadClients = file => async (dispatch) => {
  dispatch(addLoading());
  try {
    const result = await ClientsRequests.uploadCsvClients(file);
    return result;
  } finally {
    dispatch(removeLoading());
  }
};

export const getCsvClientModel = () => async (dispatch) => {
  dispatch(addLoading());
  try {
    await ClientsRequests.getCsvClientModel();
  } finally {
    dispatch(removeLoading());
  }
};

const getCsvClientsReport = () => async (dispatch) => {
  dispatch(addLoading());
  try {
    await ClientsRequests.getCsvClientsReport();
  } finally {
    dispatch(removeLoading());
  }
};

const getCsvUsersAccessReport = (clientId, standardDays, iniDate, finDate) => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await ClientsRequests.getCsvUsersAccessReport(clientId, standardDays, iniDate, finDate);
  } finally {
    dispatch(removeLoading());
  }
};

const customerProducts = (spotCheck, contractCheck, clientId) => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await ClientsRequests.customerProducts(spotCheck, contractCheck, clientId);
  } finally {
    dispatch(removeLoading());
  }
};

const getAllClients = () => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await ClientsRequests.getAllClients();
  } finally {
    dispatch(removeLoading());
  }
};

export default {
  createClients,
  getClient,
  getClientSettings,
  updateClients,
  searchSphereClient,
  uploadClients,
  getCsvClientsReport,
  getCsvClientModel,
  getCsvUsersAccessReport,
  customerProducts,
  getAllClients,
  uploadClientLogo,
};
